module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/assets/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.svg
// module chunks = styles